import styled from "styled-components";
import { Device } from "../../../../styles/screenSizes";

export const StyledLink = styled.div`
  display: inline-block;
  text-align: center;
  padding: 10px;
`;

export const StyledSubNav = styled.div`
  background-color: ${({ theme }) => theme.color.accent};
  width: 100vw;
  height: 50px;
  top: 60px;
  overflow: auto;
  white-space: nowrap;
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  @media ${Device.notLaptop} {
    justify-content: flex-start;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
